import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { GzFormFieldWebComponent } from '../../../../ui/gzForm/formField';
import { GzCheckboxWebComponent } from '../../../../ui/gzCheckbox';
import { GzTitleWebComponent } from '../../../../ui/gzTitle';
import { GzDropdownWebComponent } from '../../../../ui/gzDropdown';
import { SelectOption } from '../../../../ui/gzDropdown/types';
import { GzTextWebComponent } from '../../../../ui/gzText';
import { isHidden, toggleVisibility } from '../../../../utils/htmlElement.utils';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import {
  AccountRoleAndPrivilegesData,
  AVAILABLE_RIGHTS,
  AvailableRole,
  CompanyUserRightsMap,
  Rights,
  RightsWithOptions,
  HIDDEN_RIGHTS,
} from '../type';
import { getAccountsStrings } from '../../accountStrings/accountStrings';
import { AccountActionContext } from '../../types/AccountActionContext';
import _ from 'lodash';
import { GzInfoBoxWebComponent } from '../../../../ui/gzInfoBox';
import { CompanyData } from '../../types/CompanyData';
import { RequiredValidator } from '../../../../ui/gzForm/validators/required.validator';
import { AccountEvents } from '../../types/AccountsEvents';

export class AccountRoleAndPrivilegesWebView extends BaseWebComponentView {
  public context: AccountActionContext;

  public formGroup: FormGroup;
  public dom: {
    $roleSection: HTMLElement;
    $rightsSubtitle: HTMLElement;
    $roleRights: HTMLElement;
    $noRightsSelectedError: GzInfoBoxWebComponent;
    $rolePrivilegesSectionTitle: GzTitleWebComponent;
    $roleFormField: GzFormFieldWebComponent;
    $roleDropdown: GzDropdownWebComponent;

    $atLeastOneRightChecked: GzFormFieldWebComponent;

    $manageCompaniesRightFormField: GzFormFieldWebComponent;
    $manageCompaniesRightCheckbox: GzCheckboxWebComponent;
    $manageCompaniesRightDescription: GzTextWebComponent;

    $manageUsersFormField: GzFormFieldWebComponent;
    $manageUsersRightCheckbox: GzCheckboxWebComponent;
    $manageUsersRightDescription: GzTextWebComponent;

    $manageCompanyRightFormField: GzFormFieldWebComponent;
    $manageCompanyRightCheckbox: GzCheckboxWebComponent;
    $manageCompanyRightDescription: GzTextWebComponent;

    $manageInventoryRightFormField: GzFormFieldWebComponent;
    $manageInventoryRightCheckbox: GzCheckboxWebComponent;
    $manageInventoryRightDescription: GzTextWebComponent;

    $manageReportsRightFormField: GzFormFieldWebComponent;
    $manageReportsRightCheckbox: GzCheckboxWebComponent;
    $manageReportsRightDescription: GzTextWebComponent;

    $manageSolutionRightFormField: GzFormFieldWebComponent;
    $manageSolutionRightCheckbox: GzCheckboxWebComponent;
    $manageSolutionRightDescription: GzTextWebComponent;

    $advancedInvestigationRightFormField: GzFormFieldWebComponent;
    $advancedInvestigationRightCheckbox: GzCheckboxWebComponent;
    $advancedInvestigationRightDescription: GzTextWebComponent;

    $managePoliciesRightFormField: GzFormFieldWebComponent;
    $managePoliciesRightCheckbox: GzCheckboxWebComponent;
    $managePoliciesRightDescription: GzTextWebComponent;

    $managePoliciesReadRightFormField: GzFormFieldWebComponent;
    $managePoliciesReadRightCheckbox: GzCheckboxWebComponent;
    $managePoliciesReadRightDescription: GzTextWebComponent;

    $managePoliciesWriteRightFormField: GzFormFieldWebComponent;
    $managePoliciesWriteRightCheckbox: GzCheckboxWebComponent;
    $managePoliciesWriteRightDescription: GzTextWebComponent;
  };

  public customRights: any;
  public currentSelectedCompany: CompanyData;

  getDomElements(): void {
    this.dom = {
      $roleSection: this.shadow.querySelector('#role-privileges-section'),
      $roleRights: this.shadow.querySelector('#role-rights'),
      $rightsSubtitle: this.shadow.querySelector('#rights-subtitle'),
      $noRightsSelectedError: this.shadow.querySelector('#no-rights-selected-error'),
      $rolePrivilegesSectionTitle: this.shadow.querySelector('#role-privileges-section-title'),

      $roleFormField: this.shadow.querySelector('#role'),
      $roleDropdown: this.shadow.querySelector('#role-dropdown'),

      $atLeastOneRightChecked: this.shadow.querySelector('#at-least-one-right-checked'),

      $manageCompaniesRightFormField: this.shadow.querySelector('#manageCompanies'),
      $manageCompaniesRightCheckbox: this.shadow.querySelector('#manage-companies-checkbox'),
      $manageCompaniesRightDescription: this.shadow.querySelector('#manage-companies-description'),

      $manageUsersFormField: this.shadow.querySelector('#manageUsers'),
      $manageUsersRightCheckbox: this.shadow.querySelector('#manage-users-checkbox'),
      $manageUsersRightDescription: this.shadow.querySelector('#manage-users-description'),

      $manageCompanyRightFormField: this.shadow.querySelector('#companyManager'),
      $manageCompanyRightCheckbox: this.shadow.querySelector('#manage-company-checkbox'),
      $manageCompanyRightDescription: this.shadow.querySelector('#manage-company-description'),

      $manageInventoryRightFormField: this.shadow.querySelector('#manageInventory'),
      $manageInventoryRightCheckbox: this.shadow.querySelector('#manage-inventory-checkbox'),
      $manageInventoryRightDescription: this.shadow.querySelector('#manage-inventory-description'),

      $manageReportsRightFormField: this.shadow.querySelector('#manageReports'),
      $manageReportsRightCheckbox: this.shadow.querySelector('#manage-reports-checkbox'),
      $manageReportsRightDescription: this.shadow.querySelector('#manage-reports-description'),

      $manageSolutionRightFormField: this.shadow.querySelector('#managePlatform'),
      $manageSolutionRightCheckbox: this.shadow.querySelector('#manage-solution-checkbox'),
      $manageSolutionRightDescription: this.shadow.querySelector('#manage-solution-description'),

      $advancedInvestigationRightFormField: this.shadow.querySelector('#manageRemoteShell'),
      $advancedInvestigationRightCheckbox: this.shadow.querySelector('#advanced-investigation-checkbox'),
      $advancedInvestigationRightDescription: this.shadow.querySelector('#advanced-investigation-description'),

      $managePoliciesRightFormField: this.shadow.querySelector('#managePolicies'),
      $managePoliciesRightCheckbox: this.shadow.querySelector('#manage-policies-checkbox'),
      $managePoliciesRightDescription: this.shadow.querySelector('#manage-policies-description'),

      $managePoliciesReadRightFormField: this.shadow.querySelector('#managePoliciesRead'),
      $managePoliciesReadRightCheckbox: this.shadow.querySelector('#manage-policies-read-checkbox'),
      $managePoliciesReadRightDescription: this.shadow.querySelector('#manage-policies-read-description'),

      $managePoliciesWriteRightFormField: this.shadow.querySelector('#managePoliciesWrite'),
      $managePoliciesWriteRightCheckbox: this.shadow.querySelector('#manage-policies-write-checkbox'),
      $managePoliciesWriteRightDescription: this.shadow.querySelector('#manage-policies-write-description'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations(): void {
    this.translations = getAccountsStrings();
  }

  setTranslatedStrings(): void {
    this.dom.$rolePrivilegesSectionTitle.innerText = this.translations.rolePrivilegesTitle;
    this.dom.$noRightsSelectedError.innerText = this.translations.noRightsSelectedErrorMessage;
    this.dom.$roleFormField.label = this.translations.roleLabel;
    this.dom.$rightsSubtitle.innerText= this.translations.rightsLabel;
    this.dom.$manageCompaniesRightCheckbox.label = this.translations.manageCompaniesRightCheckboxLabel;
    this.dom.$manageCompaniesRightDescription.innerText = this.translations.manageCompaniesRightDescription;
    this.dom.$manageUsersRightCheckbox.label = this.translations.manageUsersRightCheckboxLabel;
    this.dom.$manageUsersRightDescription.innerText = this.translations.manageUsersRightDescription;
    this.dom.$manageCompanyRightCheckbox.label = this.translations.manageCompanyRightCheckboxLabel;
    this.dom.$manageCompanyRightDescription.innerText = this.translations.manageCompanyRightDescription;
    this.dom.$manageInventoryRightCheckbox.label = this.translations.manageInventoryRightCheckboxLabel;
    this.dom.$manageInventoryRightDescription.innerText = this.translations.manageInventoryRightDescription;
    this.dom.$manageReportsRightCheckbox.label = this.translations.manageReportsRightCheckboxLabel;
    this.dom.$manageReportsRightDescription.innerText = this.translations.manageReportsRightDescription;
    this.dom.$manageSolutionRightCheckbox.label = this.translations.manageSolutionRightCheckboxLabel;
    this.dom.$manageSolutionRightDescription.innerText = this.translations.manageSolutionRightDescription;
    this.dom.$advancedInvestigationRightCheckbox.label = this.translations.advancedInvestigationRightCheckboxLabel;
    this.dom.$advancedInvestigationRightDescription.innerText = this.translations.advancedInvestigationRightDescription;
    this.dom.$managePoliciesRightCheckbox.label = this.translations.managePoliciesRightCheckboxLabel;
    this.dom.$managePoliciesRightDescription.innerText = this.translations.managePoliciesRightDescription;
    this.dom.$managePoliciesReadRightCheckbox.label = this.translations.managePoliciesReadRightCheckboxLabel;
    this.dom.$managePoliciesReadRightDescription.innerText = this.translations.managePoliciesReadRightDescription;
    this.dom.$managePoliciesWriteRightCheckbox.label = this.translations.managePoliciesWriteRightCheckboxLabel;
    this.dom.$managePoliciesWriteRightDescription.innerText = this.translations.managePoliciesWriteRightDescription;
  }

  disconnected() {}

  buildSuccessView(viewData: AccountRoleAndPrivilegesData) {
    this.createFormGroup();
    this.setInitialValues();
    this.resetData();
    this.showFieldsDependingOnPlatform();

    if (viewData) {
      if (viewData.companyInfo) {
        this.currentSelectedCompany = viewData.companyInfo;
        this.setupRoleDropdown(viewData.availableRoles);
      }
      this.setFormFieldsValues(viewData);
    }
  }

  private showFieldsDependingOnPlatform(): void {
    // disable role selector on cloud create account, until user selects a company.
    if (!this.currentSelectedCompany) {
      this.dom.$roleFormField.disabled = true;
    }
  }

  private setInitialValues(): void {
    this.dom.$roleFormField.initialValue = [];
    this.toggleRightsCheckboxes({
      [AVAILABLE_RIGHTS.MANAGE_COMPANIES]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.MANAGE_USERS]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.MANAGE_PLATFORM]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.COMPANY_MANAGER]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.MANAGE_INVENTORY]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.MANAGE_POLICIES_READ]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.MANAGE_POLICIES_WRITE]: {
        checked: false,
        disabled: true,
      },
      [AVAILABLE_RIGHTS.MANAGE_REPORTS]: {
        checked: false,
        disabled: true,
      },
    });
    this.dom.$atLeastOneRightChecked.value = '';
  }

  private resetData(): void {
    this.formGroup.applyToFormGroupFields(field => {
      if (field instanceof GzFormFieldWebComponent) {
        field.discardChanges();
        field.resetField();
      }
    });
  }

  private setFormFieldsValues(viewData: AccountRoleAndPrivilegesData): void {
    if (this.context !== AccountActionContext.Edit) {
      return;
    }

    const roleId = _.get(viewData, ['role', 'roleId'], '');
    const rights = _.get(viewData, ['role', 'rights'], []);

    this.toggleRightsVisibility();
    if (!roleId) {
      // set the rights
      const rightsWithOptions = this.enrichRightsWithOptions(rights, true);
      this.toggleRightsCheckboxes(rightsWithOptions);

      // select the role
      this.selectRole('', rights);
    } else {
      this.selectRole(roleId);
    }
  }

  private createFormGroup(): void {
    this.formGroup = new FormGroup({
      atLeastOneRightChecked: this.dom.$atLeastOneRightChecked,
    });

    this.dom.$atLeastOneRightChecked.Validators = [RequiredValidator(this.translations.noRightsSelectedErrorMessage)];
  }

  public setupRoleDropdown(availableRoles: Array<AvailableRole> | undefined): void {
    this.dom.$roleFormField.disabled = true;

    if (this.dependencies.isCloud()) {
      const managesCompanies = this.currentSelectedCompany.specifics
        ? this.currentSelectedCompany.specifics?.rights?.manageCompanies
        : false;
      if (this.dom.$manageCompaniesRightFormField) {
        this.dom.$manageCompaniesRightFormField.setAttribute(!managesCompanies ? 'onprem' : 'cloud', 'true');
        this.dom.$manageCompaniesRightFormField.removeAttribute(!managesCompanies ? 'cloud' : 'onprem');
      }
    }

    if (!availableRoles || (availableRoles && !availableRoles.length)) {
      this.toggleRightsVisibility();
      return;
    }

    this.dom.$roleDropdown.options = availableRoles
      ? availableRoles.map(role => {
          if (!role._id) {
            this.customRights = role.rights;
          }
          return {
            title: role.name,
            value: role._id ? role._id : '',
            data: role.rights,
          } as SelectOption;
        })
      : [];

    // pre-select the first option on create context
    if (this.context === AccountActionContext.Create) {
      const firstOption = this.dom.$roleDropdown.options[0];
      if (firstOption) {
        this.selectRole(firstOption.value as string);
      }
    }

    this.dom.$roleFormField.disabled = false;
  }

  private selectRole(roleId: string, customRoleRights?: Rights): void {
    const matchedOption = this.dom.$roleDropdown.options.find(option =>
      roleId ? option.value === roleId : option.value === ''
    ) as SelectOption;

    if (customRoleRights) {
      matchedOption.data = customRoleRights;
    }

    if (!matchedOption) {
      return;
    }

    this.dom.$roleDropdown.selectOption(matchedOption);
    this.dom.$roleFormField.value = matchedOption.value as string;
  }

  public toggleRightsCheckboxes(rights: RightsWithOptions): void {
    this.setAdvancedInvestigation(rights);
    this.setAnalyzeData(rights);
    this.disableRightsDependingOnSelectedCompanyRights(rights);
    this.setManagePoliciesUmbrellaCheckbox(rights);

    for (const [key, options] of Object.entries(rights)) {
      const htmlCheckbox = this.mappedRightToCheckboxElement(key) as GzCheckboxWebComponent;
      if (!htmlCheckbox) {
        continue;
      }

      if (options.hasOwnProperty('checked')) {
        htmlCheckbox.checked = options?.checked;
      }

      if (options.hasOwnProperty('disabled')) {
        htmlCheckbox.disabled = options?.disabled;
      }
    }

    this.checkIfAtLeastOneRightIsChecked();
    const mustSelectTarget = this.checkIfUserMustSelectTargets();

    this.dom.$roleSection.dispatchEvent(
      new CustomEvent(AccountEvents.ToggleSelectTargets, {
        detail: {
          targetsShouldBeVisible: mustSelectTarget,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  public checkIfUserMustSelectTargets(): boolean {
    if (!this.currentSelectedCompany) {
      return false;
    }

    // Hide targets section if user choose Manage Solutions
    if (!this.dependencies.isCloud() && this.dom.$manageSolutionRightCheckbox.checked) {
      return false;
    }

    return (
      this.dom.$manageReportsRightCheckbox.checked ||
      this.dom.$manageInventoryRightCheckbox.checked ||
      this.dom.$managePoliciesRightCheckbox.checked ||
      this.dom.$manageUsersRightCheckbox.checked ||
      (this.dependencies.isCloud() &&
        !isHidden(this.dom.$manageCompaniesRightFormField) &&
        this.dom.$manageCompaniesRightCheckbox.checked)
    );
  }

  private disableRightsDependingOnSelectedCompanyRights(rights: RightsWithOptions): void {
    if (!this.currentSelectedCompany) {
      return;
    }

    // disable rights that current user does not have
    if (this.currentSelectedCompany._id === this.dependencies.getUser().company.id) {
      const currentLoggedInUserRights = this.dependencies.getUser().role.rights;
      for (const right in currentLoggedInUserRights) {
        if ((Object.values(HIDDEN_RIGHTS) as string[]).includes(right)) {
          continue;
        }
        if (!currentLoggedInUserRights[right]) {
          rights[right].disabled = true;
          rights[right].checked = false;
        }
      }
    }

    // disable rights that are not available for company
    const companyRights = _.get(this.currentSelectedCompany, ['specifics', 'rights'], '');
    for (const right in companyRights) {
      if (!companyRights[right]) {
        CompanyUserRightsMap[right].forEach((userRight: string) => {
          rights[userRight].disabled = true;
          rights[userRight].checked = false;
        });
      }
    }
  }

  private setAdvancedInvestigation(rights: RightsWithOptions): void {
    // Special case: Disable Advanced Investigation if Manage Inventory is not enabled
    if (!rights[AVAILABLE_RIGHTS.MANAGE_INVENTORY]?.checked) {
      rights[AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL] = {
        checked: false,
        disabled: true,
      };
      return;
    }

    if (!rights.hasOwnProperty(AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL)) {
      rights[AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL] = {
        disabled: false,
      };
      return;
    }

    const manageRemoteShell = rights[AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL];
    if (manageRemoteShell) {
      manageRemoteShell.disabled = manageRemoteShell.disabled ?? false;
    }
  }

  private setAnalyzeData(rights: RightsWithOptions): void {
    // Special case: Analyze Data should be automatically checked && disabled if  'Manage Companies' or 'Manage Inventory' is enabled
    if (rights[AVAILABLE_RIGHTS.MANAGE_INVENTORY]?.checked || rights[AVAILABLE_RIGHTS.MANAGE_COMPANIES]?.checked) {
      rights[AVAILABLE_RIGHTS.MANAGE_REPORTS] = {
        checked: true,
        disabled: true,
      };
      return;
    }

    if (!rights.hasOwnProperty(AVAILABLE_RIGHTS.MANAGE_REPORTS)) {
      rights[AVAILABLE_RIGHTS.MANAGE_REPORTS] = {
        disabled: false,
      };
      return;
    }

    const manageReports = rights[AVAILABLE_RIGHTS.MANAGE_REPORTS];
    if (manageReports) {
      manageReports.disabled = manageReports.disabled ?? false;
    }
  }

  private setManagePoliciesUmbrellaCheckbox(rights: RightsWithOptions): void {
    const companyRights = _.get(this.currentSelectedCompany, ['specifics', 'rights'], '');
    this.dom.$managePoliciesRightCheckbox.checked = rights[AVAILABLE_RIGHTS.MANAGE_POLICIES_READ]?.checked ?? false;
    this.dom.$managePoliciesRightCheckbox.disabled = !companyRights['manageNetworks'];

    const managePoliciesRead = rights[AVAILABLE_RIGHTS.MANAGE_POLICIES_READ];
    if (managePoliciesRead) {
      managePoliciesRead.disabled = true;
    }
  }

  private mappedRightToCheckboxElement(right: string): GzCheckboxWebComponent {
    switch (right) {
      case AVAILABLE_RIGHTS.MANAGE_COMPANIES:
        return this.dom.$manageCompaniesRightCheckbox;
      case AVAILABLE_RIGHTS.MANAGE_USERS:
        return this.dom.$manageUsersRightCheckbox;
      case AVAILABLE_RIGHTS.COMPANY_MANAGER:
        return this.dom.$manageCompanyRightCheckbox;
      case AVAILABLE_RIGHTS.MANAGE_INVENTORY:
        return this.dom.$manageInventoryRightCheckbox;
      case AVAILABLE_RIGHTS.MANAGE_POLICIES_READ:
        return this.dom.$managePoliciesReadRightCheckbox;
      case AVAILABLE_RIGHTS.MANAGE_POLICIES_WRITE:
        return this.dom.$managePoliciesWriteRightCheckbox;
      case AVAILABLE_RIGHTS.MANAGE_REPORTS:
        return this.dom.$manageReportsRightCheckbox;
      case AVAILABLE_RIGHTS.MANAGE_REMOTE_SHELL:
        return this.dom.$advancedInvestigationRightCheckbox;
      case AVAILABLE_RIGHTS.MANAGE_PLATFORM:
        return this.dom.$manageSolutionRightCheckbox;
      default:
        return new GzCheckboxWebComponent();
    }
  }

  public setRightsForRole(rights: Rights): void {
    this.toggleRightsVisibility();

    const rightsWithOptions = this.enrichRightsWithOptions(rights, true);

    this.toggleRightsCheckboxes(rightsWithOptions);
  }

  private toggleRightsVisibility(): void {
    this.dom.$roleRights.querySelectorAll('.role-right').forEach(roleRight => {
      toggleVisibility(
        roleRight as GzFormFieldWebComponent,
        this.dependencies.isCloud() ? roleRight.hasAttribute('cloud') : roleRight.hasAttribute('onprem')
      );
    });

    this.dom.$roleFormField.disabled = false;
  }

  public selectCustomRole(): void {
    this.dom.$roleDropdown.selectedOption = this.dom.$roleDropdown.options.find(
      option => option.value === ''
    ) as SelectOption;
  }

  public checkIfAtLeastOneRightIsChecked(): void {
    // does not check if there is no company
    if (!this.currentSelectedCompany) {
      toggleVisibility(this.dom.$noRightsSelectedError, false);
      return;
    }

    let atLeastOneRightChecked;
    if (this.dependencies.isCloud()) {
      atLeastOneRightChecked =
        this.dom.$manageCompaniesRightCheckbox.checked ||
        this.dom.$manageUsersRightCheckbox.checked ||
        this.dom.$manageCompanyRightCheckbox.checked ||
        this.dom.$manageInventoryRightCheckbox.checked ||
        this.dom.$managePoliciesReadRightCheckbox.checked ||
        this.dom.$managePoliciesWriteRightCheckbox.checked ||
        this.dom.$manageReportsRightCheckbox.checked ||
        this.dom.$advancedInvestigationRightCheckbox.checked;
    } else {
      atLeastOneRightChecked =
        this.dom.$manageUsersRightCheckbox.checked ||
        this.dom.$manageCompanyRightCheckbox.checked ||
        this.dom.$manageInventoryRightCheckbox.checked ||
        this.dom.$managePoliciesReadRightCheckbox.checked ||
        this.dom.$managePoliciesWriteRightCheckbox.checked ||
        this.dom.$manageReportsRightCheckbox.checked ||
        this.dom.$manageSolutionRightCheckbox.checked;
    }

    this.dom.$atLeastOneRightChecked.value = atLeastOneRightChecked ? true : '';
    toggleVisibility(this.dom.$noRightsSelectedError, !atLeastOneRightChecked);
  }

  public enrichRightsWithOptions(rights: Rights, setEnabled = false): RightsWithOptions {
    const rightsWithOptions = {};
    for (const [key, value] of Object.entries(rights)) {
      const option = {
        checked: value,
      } as any;
      if (setEnabled) {
        option.disabled = false;
      }
      rightsWithOptions[key] = option;
    }
    return rightsWithOptions;
  }
}
